import { useElementalListsStore } from '../stores/useElementalListsStore'
import { useRecentElementalQuery } from './query/recentElemental/recentElementalQuery'

export const useRecentElementals = (
  size?: number,
) => {
  const user = useUser()
  const userId = computed(() => user.value?.id)
  const { data, isLoading, refetch, isError } = useRecentElementalQuery({
    userId,
    size,
  })
  const { state } = useElementalListsStore()

  const elementalsFiltered = computed(() => {
    const query = state.query?.trim().toLowerCase()
    const activeFilters = Object.values(state.viewsActives ?? {}).filter(view => view?.filterActive).map(view => view?.elementaltype)

    const recentElementalFiltered = data.value?.filter((item) => {
      return activeFilters.includes(item.elementalTypeId)
    }) ?? []

    if (!query)
      return recentElementalFiltered

    return recentElementalFiltered?.filter(({ title, id }) => {
      const idStr = id.toString().toLowerCase()
      return title.toLowerCase().includes(query) || idStr.includes(query)
    }) || []
  })

  return {
    elementalsFiltered,
    isLoading,
    refetch,
    isError,
  }
}
